import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=52bc52ea"
import script from "./ExportData.vue?vue&type=script&lang=js"
export * from "./ExportData.vue?vue&type=script&lang=js"
import style0 from "./ExportData.vue?vue&type=style&index=0&id=52bc52ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports